export const Wrapper = (color) => ({
  backgroundColor: color,
  maxWidth: { xs: '100%', md: '416px', xl: '490px' },
  marginBottom: 6,
});

export const ImageWrapper = {
  cursor: 'pointer',
  position: 'relative',
  height: { xs: '364px', sm: '500px', md: '400px' },
};

export const Quote = (color) => ({
  fontSize: '40px',
  color,
  height: '40px',
  display: 'block',
  fontWeight: 700,
});

export const PlayIconWrapper = {
  alignItems: 'center',
  backgroundColor: '#91FA87',
  borderRadius: '50%',
  display: 'flex',
  height: '48px',
  justifyContent: 'center',
  position: 'absolute',
  right: 'calc(50% - 24px)',
  top: 'calc(50% - 24px)',
  width: '48px',
  zIndex: 1,

  svg: {
    color: '#004609',
    fontSize: '32px',
  },
};
